import { ActionModel } from '~contentful/models/actions/action.model';

export class LinkModel extends ActionModel {
  url: string;
  openNewTab: boolean;

  get isInternal () {
    return !/^(?:https?:\/\/|\/\/)/.test(this.url);
  }

  public get contextLabel () {
    return this.forModel.contextLabel;
  }

  public get contextValue () {
    return this.forModel.contextValue;
  }

  protected get extraContext () {
    const extra: any = {};
    /*
     If it has a href tag that starts with https://go.zipmoney.com.au then it is a UTM
     */
    if (this.url) {
      if (this.url.startsWith('https://go.zipmoney.com.au')) {
        extra.utm_link    = this.url;
        extra.utm_source  = 'zip';
        extra.utm_content = this.contextValue;
        extra.utm_medium  = 'gift-cards';
      } else {
        extra.itm_source  = 'zip';
        extra.itm_link    = this.url;
        extra.itm_medium  = 'gift-cards';
        extra.itm_content = this.contextValue;
      }
    }

    return extra;
  }
}
